export const ResourceMain = [
  {
    name: "Web Development",
    to: "/webd",
    description:
      "Discover the latest in web development trends and techniques. Explore tutorials, frameworks, and tools to enhance your skills and create stunning websites that engage and inspire.Stay ahead in the web dev world. ",
    image: require("./ResourceIcons/webDev.jpg"),
  },
  {
    name: "Android Development",
    description:
      "Unlock the power of Android development with our comprehensive resources. From coding tips to app design strategies, access the tools and knowledge you need to create cutting-edge Android applications that captivate users and drive innovation.",
    to: "/android",
    image: require("./ResourceIcons/androidDev.png"),
  },
  {
    name: "AI/ML",
    to: "/aiml",
    description:
      "Dive into the world of AI and ML with our comprehensive resources. From beginner guides to advanced techniques, we offer insights, tutorials, and datasets to fuel your journey into artificial intelligence and machine learning. Unlock the potential of AI today.",
    image: require("./ResourceIcons/AIML.png"),
  },
  {
    name: "Data Science",
    description:
      "Unlock the power of data with our Data Science resources. Dive into analytics, machine learning, and data visualization. Elevate your data-driven decisions and skills with our curated articles, courses, and insights.",
    to: "/dataScience",
    image: require("./ResourceIcons/dataScience.jpg"),
  },
  {
    name: "AR/VR",
    description:
      "Dive into the immersive world of AR/VR technology. Access guides, case studies, and resources to unlock the potential of augmented and virtual reality, revolutionizing industries and experiences. Explore the future today.",
    to: "/arvr",
    image: require("./ResourceIcons/arvr.png"),
  },
  {
    name: "Internet of Things",
    description:
      "Explore the Internet of Things (IoT) with our comprehensive resources. Learn about IoT applications, devices, security, and trends. Harness the power of connected devices and unlock new possibilities in the digital world.",
    to: "/iot",
    image: require("./ResourceIcons/IoT.png"),
  },
  {
    name: "Competitive Programming",
    description:
      " Explore the world of competitive programming with our comprehensive resources. From beginner guides to advanced techniques, we offer insights, tutorials, and datasets to fuel your journey into competitive programming.",
    to: "/cp",
    image: require("./ResourceIcons/web.png"),
  },
  {
    name: "DevOps",
    description:
      " Unlock the full potential of DevOps with our comprehensive resources. Whether you're a beginner looking to streamline workflows or an experienced practitioner seeking advanced strategies, our guides cover automation, collaboration, security, monitoring, and scalability.",
    to: "/devops",
    image: require("./ResourceIcons/devops.png"),
  },
  {
    name: "BlockChain",
    description:
      " Explore the limitless world of blockchain innovation. Whether you're a beginner or an experienced blockchain enthusiast, our comprehensive resources will empower you to unlock the full potential of blockchain.",
    to: "/blockchain",
    image: require("./ResourceIcons/blockchain.png"),
  },
  {
    name: "DSA",
    description:
      " Mastering DSA is fundamental in software development, providing the backbone for efficient problem-solving and algorithmic optimization, crucial for building robust and scalable applications.",
    to: "/dsa",
    image: require("./ResourceIcons/dsa.jpg"),
  },
  {
    name: "Cyber Security",
    description:
      " Cybersecurity involves protecting digital systems, networks, and data from cyber threats. It includes measures like encryption, firewalls, and vulnerability assessments to ensure data integrity and confidentiality against evolving cyber risks.",
    to: "/cybersecurity",
    image: require("./ResourceIcons/Cyber-Security.png"),
  },
  {
    name: "UI/UX Designing",
    description:
      " UI/UX Designing focuses on creating engaging and intuitive user interfaces and experiences. It blends aesthetics with usability, aiming to enhance user satisfaction by crafting designs that are visually appealing and functionally effective for optimal user interaction.",
    to: "/uiux",
    image: require("./ResourceIcons/uiux.png"),
    
  },
  
];
